import apiInstance from 'src/apis/config/axiosConfig';

export type RoomOccupancyFilter = 'vacant' | 'occupied' | 'unknown';

export interface RoomListResult {
  rooms: Array<{
    id: string;
    name?: string;
    floorName?: string | null;
    status?: string;
    buildingId?: string;
    description?: string | null;
    pinCode?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  }>;
  total: number;
}

export interface RoomBatchDeleteResult {
  success: boolean;
  deleted: string[];
  failed: Array<{id: string; message: string}>;
  deletedCount: number;
  failedCount: number;
}

/**
 * Thin room helpers for query params / endpoints the OpenAPI client does not
 * yet expose (status filter, batch delete).
 */
export const roomClient = {
  find: (params: {
    buildingId?: string;
    pageSize?: number;
    pageNum?: number;
    status?: RoomOccupancyFilter | '';
  }) => {
    const query: Record<string, string | number> = {};
    if (params.buildingId) query.buildingId = params.buildingId;
    if (params.pageSize != null) query['page.size'] = params.pageSize;
    if (params.pageNum != null) query['page.num'] = params.pageNum;
    if (params.status) query.status = params.status;
    return apiInstance.get<RoomListResult>('/room/rooms', {params: query});
  },

  batchDelete: (roomIds: string[]) =>
    apiInstance.post<RoomBatchDeleteResult>('/room/rooms/batch-delete', {
      roomIds,
    }),
};
